import { Form, Input, InputProps } from 'antd';
import { useField } from 'formik';
import { FormLabel } from './FormLabel';

interface Props extends InputProps {
  fieldName: string;
  label?: string;
  width?: number;
}

export const TextInput = ({ fieldName, label, width, ...rest }: Props): JSX.Element => {
  const [{ value }, { touched, error }, { setValue, setTouched }] = useField<string>(fieldName);

  return (
    <Form.Item
      labelAlign="left"
      validateStatus={touched && error ? 'error' : 'success'}
      label={label ? <FormLabel label={label} /> : undefined}
      help={touched && error ? error : undefined}
      style={{ marginBottom: 0 }}
      labelCol={{ style: { padding: 0 } }}>
      <Input {...rest} value={value || undefined} onChange={(e): void => setValue(e.target.value)} onFocus={(): void => setTouched(false)} style={{ borderRadius: 5, width: width }} />
    </Form.Item>
  );
};
